export const loadStorageState = name => {
	try {
		const serializedState = localStorage.getItem(name);
		if (serializedState === null) {
			return Promise.resolve(null);
		}
		return Promise.resolve(JSON.parse(serializedState));
	} catch (err) {
		return Promise.reject(err);
	}
};

export const saveStorageState = (name, data) => {
	try {
		const serializedState = JSON.stringify(data);
		localStorage.setItem(name, serializedState);
		return Promise.resolve(true);
	} catch (err){
		console.error(err);
		return Promise.reject(err);
	}
};



// WEBPACK FOOTER //
// ./src/helpers/localStorageService.js